import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Button, Box, Tab, TabContext, TabList} from 'views/components';
import {ArrowDownward, ArrowUpward} from 'views/icons';
import {Translate} from 'views/module';

import SelectCorrespondanceType from './SelectCorrespondanceType';

{/* Header for the Correspondance. Includes the title, which correspondance user wants to view and order */}
const NewMessageHeader = (props) => {
  const {
    clientData,
    sortDir,
    setSortDir,
    corType,
    setCorType,
    messageMode,
    setMessageMode,
    messageRecipientRn,
    setMessageRecipientRn,
  } = props;

  const sortDesc = 'DESC';
  const sortAsc = 'ASC';

  const relationshipOptions = Object.values(clientData.relationships).map((relationship) => {
    return {
      key: relationship.relationshipRn,
      text: relationship.name,
    };
  });

  const isInternalNotesSelected = messageMode === 'INTERNAL_NOTES';
  const selectedMessageTab = isInternalNotesSelected ? 'INTERNAL_NOTES' : messageRecipientRn;

  const onMessageTabChange = (_event, newValue) => {
    if (newValue === 'INTERNAL_NOTES') {
      setMessageMode('INTERNAL_NOTES');
      return;
    }

    setMessageMode('SEND_MESSAGE');
    setMessageRecipientRn(newValue);
  };

  const onSortClick = () => {
    const invertSortDir = sortDir === sortDesc ? sortAsc : sortDesc;
    setSortDir(invertSortDir);
  };

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Stack
          sx={{
            minWidth: 0,
          }}
        >
          <TabContext value={selectedMessageTab}>
            <TabList
              onChange={onMessageTabChange}
              variant="scrollable"
              scrollButtons={false}
              sx={{
                'minHeight': '46px',
                'px': '6px',
                'py': '4px',
                'gap': '5px',
                'backgroundColor': '#EEEEEE',
                'borderBottom': 'none',
                'borderRadius': '8px',
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTabs-flexContainer': {
                  gap: '5px',
                  width: 'max-content',
                },
                '& .MuiTabs-scroller': {
                  overflowX: 'auto !important',
                  overflowY: 'hidden',
                  scrollbarWidth: 'thin',
                  msOverflowStyle: 'auto',
                },
                '& .MuiTabs-scrollButtons': {
                  display: 'none',
                },
                '& .MuiTab-root': {
                  'minHeight': '38px',
                  'minWidth': '107px',
                  'px': '14px',
                  'py': '12px',
                  'borderRadius': '6px',
                  'textTransform': 'none',
                  'fontSize': '12px',
                  'lineHeight': '16px',
                  'fontWeight': 700,
                  'color': '#6B6761',
                  'transition': 'background-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease',
                  '&.Mui-selected': {
                    color: '#000000',
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
                  },
                },
              }}
            >
              <Tab
                label={<Translate expression='client.ClientDetail.Correspondance.NewMessage.InternalNotes' />}
                value="INTERNAL_NOTES"
                sx={{
                  minWidth: '118px',
                }}
              />
              {
                relationshipOptions.map((relationshipOption) => {
                  return (
                    <Tab
                      key={relationshipOption.key}
                      label={relationshipOption.text}
                      value={relationshipOption.key}
                      sx={{
                        maxWidth: '160px',
                      }}
                    />
                  );
                })
              }
            </TabList>
          </TabContext>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
        >
          <SelectCorrespondanceType
            corType={corType}
            setCorType={setCorType}
          />
          <Button
            variant="text"
            endIcon={sortDir === sortDesc ? <ArrowDownward /> : <ArrowUpward />}
            onClick={onSortClick}
            sx={{
              'textTransform': 'none',
              'fontWeight': 500,
              'color': '#484442',
              '&:hover': {
                backgroundColor: 'rgba(118, 118, 118, 0.1)',
              },
              'borderRadius': '4px',
              'py': 0.5,
              'pl': 1,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{fontWeight: 500, fontSize: '12px'}}
            >
              {
                sortDir === sortDesc ?
                <Translate expression='client.ClientDetail.Correspondance.Sort.NewestFirst'/>:
                <Translate expression='client.ClientDetail.Correspondance.Sort.OldestFirst'/>
              }
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
NewMessageHeader.propTypes = {
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
    CALENDLY_UPDATE: PropTypes.bool.isRequired,
    DIALPAD_SMS_TEXT: PropTypes.bool.isRequired,
    DIALPAD_CALL_TRANSCRIPT: PropTypes.bool.isRequired,
    EMAIL: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
  sortDir: PropTypes.string.isRequired,
  setSortDir: PropTypes.func.isRequired,
  clientData: PropTypes.shape({
    relationships: PropTypes.object,
  }).isRequired,
  messageMode: PropTypes.string.isRequired,
  setMessageMode: PropTypes.func.isRequired,
  messageRecipientRn: PropTypes.string.isRequired,
  setMessageRecipientRn: PropTypes.func.isRequired,
};

export default React.memo(NewMessageHeader);
